export const AXIOS_ERROR_CODE = {
  REQUEST_CANCELED: 'ERR_CANCELED',
  CONNECTION_ABORTED: 'ECONNABORTED',
  TIMED_OUT: 'ETIMEDOUT'
} as const;

export const AXIOS_TIMEOUT_CODES: string[] = [
  AXIOS_ERROR_CODE.CONNECTION_ABORTED,
  AXIOS_ERROR_CODE.TIMED_OUT
];

export const DOM_EXCEPTION_NAME = {
  ABORT: 'AbortError',
  NOT_ALLOWED: 'NotAllowedError'
} as const;
